<script setup lang="ts">
import store from "@/store";
import { onBeforeMount, onMounted, ref, watch } from "vue";
import { getUser, removeUser } from "@/common/services/user";
import { userProfile } from "@/common/api/rest/user";

import { PanelTheme } from "@/common/themes";

const isMobile = ref(false);

function fecthProfile() {
  userProfile().then((response) => {
    const { success, data, code } = response;
    if (success) {
      store.commit("SET_PROFILE", data);
    } else {
      if (code === 401) removeUser();
    }
  });
}

onBeforeMount(() => {
  const user = getUser();
  if (!user) {
    removeUser();
    return;
  }

  fecthProfile();
  store.commit("SET_USER", user);
  store.commit("SET_LOGGED", true);
});

watch(
  () => isMobile.value,
  () => {
    store.commit("SET_MOBILE", isMobile.value);
  }
);

onMounted(() => {
  isMobile.value = window.innerWidth < 1024;

  window.addEventListener("resize", () => {
    isMobile.value = window.innerWidth < 1024;
  });
});
</script>

<template>
	<template v-if="store.getters.logged">
		<panel-theme>
			<router-view />
		</panel-theme>
	</template>
	<template v-else>
		<router-view />
	</template>
</template>
